import home from './home'
import user from './user'
import code from './code'
import userWallet from './user_wallet'
import chain from './chain'
import videoAdv from './video_adv'
import videoInvest from './video_invest'
import userApply from './user_apply'
import video from './video'
import profit from './profit'
import tools from './tools'
import chat from './chat'
import gift from './gift'
import userMessage from './user_message'
import bank from './bank'

export default {
  home,
  user,
  code,
  userWallet,
  chain,
  videoAdv,
  videoInvest,
  userApply,
  video,
  profit,
  tools,
  chat,
  gift,
  userMessage,
  bank
}
